import { folderIsBeingEmptied } from 'owa-locstrings/lib/strings/folderisbeingemptied.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47710 */
import EmptyStateProps from '../utils/EmptyStateProps';
import getDisplayPropertiesForEmptyList from '../utils/getDisplayPropertiesForEmptyList';
import { observer } from 'mobx-react-lite';
import { isBulkActionInState, BulkActionStateEnum } from 'owa-bulk-action-store';
import {
    getFocusedFilterForTable,
    getInboxClassificationFilterForTable,
} from 'owa-mail-list-store';
import { listViewStore } from 'owa-mail-list-store';
import { MessageAdList } from 'owa-mail-messagead-list-view';
import { isReadingPanePositionBottom } from 'owa-mail-layout';
import { ActionSource } from 'owa-mail-store';
import { MailListViewState } from 'owa-mail-store/lib/store/schema/MailListViewState';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

import * as React from 'react';
import { isInboxPlusEnabled } from 'owa-mail-inbox-plus-store/lib/selectors/inboxPlusFlightUtil';

const classNames = require('classnames');
const styles = require('./MailListEmptyState.scss');

export interface EmptyListViewProps {
    tableViewId: string;
    stateType: MailListViewState;
    clearFilterCommand: (actionSource: ActionSource) => void;
    reloadCommand: (actionSource: ActionSource) => void;
    shouldShowMessageAdList: boolean;
}

const MailListEmptyState = observer(function MailListEmptyState(props: EmptyListViewProps) {
    const { tableViewId, stateType, clearFilterCommand, reloadCommand } = props;

    let emptyState: EmptyStateProps = {
        mainMessage: null,
        detailMessage: null,
        linkMessage: null,
        linkCommand: null,
        icon: null,
    };

    emptyState = getDisplayPropertiesForEmptyList(
        tableViewId,
        stateType,
        clearFilterCommand,
        reloadCommand
    );

    const messageContainerClassNames = classNames(
        styles.infoMessageContainer,
        isReadingPanePositionBottom() ? styles.isReadingPaneBottom : ''
    );

    const mainMessageClassNames = classNames(styles.messageText, styles.mainMessageText);

    const detailMessageClassNames = classNames(styles.messageText, styles.detailsMessageText);

    const linkMessageClassNames = classNames(styles.messageText, styles.linkMessageText);

    let isBulkAction = false; // Assume no bulk action is running by default

    const tableView = listViewStore.tableViews.get(tableViewId);

    const folderId = tableView.tableQuery.folderId;
    isBulkAction =
        isBulkActionInState(folderId, BulkActionStateEnum.Running) ||
        isBulkActionInState(folderId, BulkActionStateEnum.Uninitialized);

    // Only fire the native ad when the listview state is really empty. Sometimes, this is in the loading state.
    const needShowMessageAdList =
        props.shouldShowMessageAdList && props.stateType == MailListViewState.Empty;
    return (
        <>
            {needShowMessageAdList && (
                <div className={styles.adContainer}>
                    <MessageAdList
                        loadInOtherPivot={
                            getFocusedFilterForTable(listViewStore.tableViews.get(tableViewId)) ==
                            FocusedViewFilter.Other
                        }
                        loadInEmptyPivot={true}
                        loadInItemView={
                            tableView.tableQuery.listViewType == ReactListViewType.Message
                        }
                        inboxClassificationFilter={
                            isInboxPlusEnabled()
                                ? getInboxClassificationFilterForTable(tableView.id)
                                : null
                        }
                    />
                </div>
            )}
            {!needShowMessageAdList && (
                <div className={messageContainerClassNames}>
                    {emptyState.icon && <img src={emptyState.icon} width="120px" height="120px" />}
                    {emptyState.mainMessage && (
                        <div className={mainMessageClassNames}>
                            {isBulkAction ? loc(folderIsBeingEmptied) : emptyState.mainMessage}
                        </div>
                    )}
                    {emptyState.detailMessage && (
                        <div className={detailMessageClassNames}>{emptyState.detailMessage}</div>
                    )}
                    {emptyState.linkMessage && (
                        <div
                            className={linkMessageClassNames}
                            onClick={() => {
                                emptyState.linkCommand('EmptyListState');
                            }}>
                            {emptyState.linkMessage}
                        </div>
                    )}
                </div>
            )}
        </>
    );
});
export default MailListEmptyState;
